import { useState } from 'react'
import { Badge, Dropdown } from 'react-bootstrap'
import { FaEllipsisV, FaEdit, FaTrash, FaClock, FaFile } from 'react-icons/fa'
import ViewFile from '../Views/ViewFile';
import { useQuery } from 'react-query';
import { getFiles } from '../../../api/agent';
import { ObjectId } from '../../../models';
import { IFile } from '../../../models/file';
import DeleteDataItem from '../DeleteDataItem';
// import FileStatus from './Train/FileStatus';
import { useOrgContext } from '../../../context/org';
import DataStatus from '../DataStatus';

type Props = {
    orgId: ObjectId;
    files: IFile[];
	permission: boolean;
}

function ListFiles({orgId, files, permission }: Props) {
    const [currFile, setCurrFile] = useState<IFile>();
    const [deleteItem, setDeleteItem] = useState<{
        show: boolean;
        id: string;
        name: string;
		agentId: string;
    }>({ show: false, id: '', name: '', agentId: '' });

  return (
    <>
        {
            currFile && 
            <ViewFile 
                file={currFile} 
                setCurrFile={setCurrFile}
            />
        }
        {
			<DeleteDataItem 
				show={deleteItem.show}
                onClose={() => setDeleteItem({ show: false, id: '', name: '', agentId: '' })}
                orgId={orgId}
                agentId={deleteItem.agentId}
                itemId={deleteItem.id}
                itemType="file"
                itemName={deleteItem.name}
			/>
		}
        
        <div style={{ backgroundColor: "#2d2d2d", border: "1px solid #444", borderRadius: "12px", overflow: "hidden", marginBottom: "24px" }}>
            {/* Header */}
            <div className="p-4 border-bottom" style={{ borderColor: "#444" }}>
                <div className="d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center">
                        <div 
                            className="me-3 d-flex align-items-center justify-content-center"
                            style={{
                                width: "40px",
                                height: "40px",
                                backgroundColor: "#28a745",
                                borderRadius: "10px"
                            }}
                        >
                            <FaFile className="text-white" size={18} />
                        </div>
                        <div>
                            <h5 className="text-light mb-0" style={{ fontSize: "18px", fontWeight: "600" }}>
                                Uploaded Files
                            </h5>
                            <small style={{ color: "#999" }}>Document files for training</small>
                        </div>
                    </div>
                    <Badge bg="secondary" className="px-2 py-1">
                        {files.length} items
                    </Badge>
                </div>
            </div>

            {/* Content */}
            <div className="p-0">
                {files.map((file, index) => (
                    <div 
                        key={index}
                        className="p-4 d-flex align-items-center justify-content-between"
                        style={{ 
                            borderBottom: index < files.length - 1 ? "1px solid #444" : "none",
                            transition: "background-color 0.2s ease"
                        }}
                        onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#333"}
                        onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "transparent"}
                    >
                        <div className="flex-grow-1">
                            <div className="d-flex align-items-center mb-2">
                                <button
                                    className="btn btn-link p-0 text-decoration-none"
                                    onClick={() => setCurrFile(file)}
                                    style={{ 
                                        fontSize: "16px", 
                                        fontWeight: "500",
                                        color: "#fff",
                                        border: "none",
                                        background: "none"
                                    }}
                                    onMouseEnter={(e) => e.currentTarget.style.color = "#007bff"}
                                    onMouseLeave={(e) => e.currentTarget.style.color = "#fff"}
                                >
                                    {file.name}
                                </button>
                            </div>
                            <div className="d-flex align-items-center" style={{ fontSize: "14px", color: "#ccc" }}>
                                <FaClock className="me-2" size={12} />
                                <span>Updated {new Date(file.updatedAt).toDateString()}</span>
                            </div>
                        </div>

                        <div className="d-flex align-items-center">
                            <div className="me-3">
                                <DataStatus
                                    id={file.id}
                                    orgId={orgId}
                                    agentId={file.agentId}
                                    status={file.status}
                                    type='file'
                                />
                            </div>
                            
                            <Dropdown align="end">
                                <Dropdown.Toggle 
                                    variant="link"
                                    className="p-0 border-0"
                                    disabled={permission}
                                    style={{ fontSize: "14px", color: "#ccc" }}
                                >
                                    <FaEllipsisV />
                                </Dropdown.Toggle>

                                <Dropdown.Menu
                                    style={{ 
                                        backgroundColor: "#333", 
                                        borderColor: "#555",
                                        minWidth: "120px"
                                    }}
                                >
                                    <Dropdown.Item 
                                        onClick={() => setCurrFile(file)}
                                        className="d-flex align-items-center"
                                        style={{ 
                                            fontSize: "14px", 
                                            color: "#fff",
                                            backgroundColor: "transparent"
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor = "#007bff";
                                            e.currentTarget.style.color = "#fff";
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor = "transparent";
                                            e.currentTarget.style.color = "#fff";
                                        }}
                                    >
                                        <FaEdit className="me-2" size={12} />
                                        Edit
                                    </Dropdown.Item>
                                    <Dropdown.Item 
                                        onClick={() => setDeleteItem({ 
											show: true, 
											id: file.id, 
											name: file.name,
											agentId: file.agentId
										})}
                                        className="d-flex align-items-center"
                                        style={{ 
                                            fontSize: "14px", 
                                            color: "#fff",
                                            backgroundColor: "transparent"
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor = "#dc3545";
                                            e.currentTarget.style.color = "#fff";
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor = "transparent";
                                            e.currentTarget.style.color = "#fff";
                                        }}
                                    >
                                        <FaTrash className="me-2" size={12} />
                                        Delete
                                    </Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    </>
  )
}

export default ListFiles